(function () {
  function initTabs(tabList) {
    var section = tabList.closest("[data-collection-grid]");
    if (!section) return;

    var grid = section.querySelector("[data-cg-grid]");
    var countEl = section.querySelector("[data-cg-count]");
    var buttons = tabList.querySelectorAll("[data-scg-tab]");
    var nav = tabList.closest(".scg-tabs");
    var scroller = nav ? nav.querySelector("[data-scg-scroll]") : null;
    var indicator = nav ? nav.querySelector("[data-scg-indicator]") : null;

    function currentTab() {
      var active = tabList.querySelector(".is-active[data-scg-tab]");
      return active ? active.getAttribute("data-scg-tab") || "" : "";
    }

    function positionIndicator() {
      if (!indicator || !nav) return;
      var active = tabList.querySelector(".is-active[data-scg-tab]");
      if (!active) {
        indicator.style.setProperty("--scg-ind-o", "0");
        return;
      }
      // measured geometry — robust to flex, scroll offset, transforms
      var navRect = nav.getBoundingClientRect();
      var r = active.getBoundingClientRect();
      var clip = scroller ? scroller.getBoundingClientRect() : navRect;
      var onScreen = r.right > clip.left + 1 && r.left < clip.right - 1;
      indicator.style.setProperty("--scg-ind-x", r.left - navRect.left + "px");
      indicator.style.setProperty("--scg-ind-w", r.width + "px");
      indicator.style.setProperty("--scg-ind-o", onScreen ? "1" : "0");
    }

    // fade the tab row at whichever edge still has hidden tabs
    function updateFades() {
      if (!scroller) return;
      var max = scroller.scrollWidth - scroller.clientWidth;
      var sl = scroller.scrollLeft;
      scroller.style.setProperty("--scg-fade-start", sl > 4 ? "28px" : "0px");
      scroller.style.setProperty(
        "--scg-fade-end",
        sl < max - 4 ? "28px" : "0px"
      );
    }

    function refresh() {
      positionIndicator();
      updateFades();
    }

    function apply(tab, pushUrl) {
      var cards = section.querySelectorAll("[data-scg-card]");
      var shown = 0;
      var needle = " " + tab + " ";

      cards.forEach(function (card) {
        var vals = " " + (card.getAttribute("data-scg-tabs") || "") + " ";
        var match = !tab || vals.indexOf(needle) !== -1;
        card.hidden = !match;
        if (match) shown++;
      });

      buttons.forEach(function (btn) {
        var on = (btn.getAttribute("data-scg-tab") || "") === tab;
        btn.classList.toggle("is-active", on);
        if (on) btn.setAttribute("aria-current", "true");
        else btn.removeAttribute("aria-current");
      });

      if (countEl) {
        countEl.textContent = countEl.textContent.replace(/\d[\d,]*/, shown);
      }

      if (pushUrl) {
        try {
          var url = new URL(window.location.href);
          if (tab) url.searchParams.set("tab", tab);
          else url.searchParams.delete("tab");
          window.history.replaceState({}, "", url);
        } catch (e) {}
      }

      refresh();
    }

    tabList.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-scg-tab]");
      if (!btn || !tabList.contains(btn)) return;
      var tab = btn.getAttribute("data-scg-tab") || "";
      apply(tab, true);
      try {
        btn.scrollIntoView({ inline: "nearest", block: "nearest" });
      } catch (e2) {}
    });

    // keep the bar under the active tab + update the edge fades while scrolling
    if (scroller) {
      var raf;
      scroller.addEventListener(
        "scroll",
        function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            refresh();
          });
        },
        { passive: true }
      );
    }

    window.addEventListener("resize", refresh);

    // Re-apply the active tab to cards added by Load More / infinite scroll.
    if (grid && "MutationObserver" in window) {
      new MutationObserver(function () {
        var tab = currentTab();
        if (tab) apply(tab, false);
        else refresh();
      }).observe(grid, { childList: true });
    }

    // Restore the tab from ?tab= (deep link / refresh / back-forward nav) —
    // Liquid can't seed this, so the client does it.
    function syncFromUrl() {
      var urlTab = "";
      try {
        urlTab = new URL(window.location.href).searchParams.get("tab") || "";
      } catch (e) {}
      if (urlTab === currentTab()) return;
      var sel =
        window.CSS && CSS.escape ? CSS.escape(urlTab) : urlTab.replace(/"/g, '\\"');
      if (!urlTab || tabList.querySelector('[data-scg-tab="' + sel + '"]')) {
        apply(urlTab, false);
      }
    }
    syncFromUrl();
    window.addEventListener("popstate", syncFromUrl);

    // first paint
    refresh();
    // fonts / images can shift widths — re-measure shortly after
    setTimeout(refresh, 250);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh);
    }
  }

  function boot() {
    document.querySelectorAll("ul[data-scg-tabs]").forEach(initTabs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
